import React, { useContext, useState } from "react";
import accountIcon from "../../Assets/Images/accout-holder-icon.png";
import DynamicTextField from "../../Common/Textfield/Textfield";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneNumberInput from "../../Common/PhoneNumberInput/PhoneNumberInput";
import Button from "../../Common/Button/Button";
import "./Signup.css";
import completeIcon from "../../Assets/Images/card-text-white-tick.png";
import { DynamicContext } from "../../Context/DynamicContext";
import {
  VYLABS_BASE_URL,
  // SIGNUP_URL,
  // CREATE_TENANT,
  SEND_OTP,
} from "../../helper/url_helper";
import { post } from "../../helper/Api_helper";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import backIcon from "../../Assets/Images/arrow-right.png";
import { useNavigate } from "react-router-dom";
import optionsData from "../../Assets/Json/StaticOptions.json";
import SelectInput from "../../Common/Select-Input/SelectInput";
import { TENANT_OTP_API_KEY } from "../../Tenant-Config/TenantConfig";
import VerifyOtp from "../OTP-Pages/VerifyOtp";
function AdminSignup() {
  const { StaticOptions = {} } = optionsData || {};
  const { knowAboutUs = [] } = StaticOptions || {};
  const navigate = useNavigate();
  const {
    // setSignupPassword,
    // setSignupEmail,
    // setSignupCompleted,
    // tempAdminSignupData,
    setTempAdminSignupData,
    showOtpPage,
    setShowOtpPage,
  } = useContext(DynamicContext);
  const [isLoading, setIsLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    firstname: Yup.string()
      .required("First name is required"),
    lastname: Yup.string()
      .required("Last name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email address"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^\+?[1-9]\d{1,14}$/, "Please enter a valid phone number"),
    newpassword: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      ),
    confirmNewPassword: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("newpassword"), null], "Passwords must match"),
    companyName: Yup.string()
      .required("Company name is required")
      .matches(
        /^[A-Za-z\s]+$/,
        "Company name can only contain letters and spaces",
      ),
  });

  const handleSendOTP = async () => {
    setIsLoading(true);
    try {
      const otpResponse = await post(
        VYLABS_BASE_URL,
        SEND_OTP,
        {
          email: formik.values.email,
        },
        {
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        },
      );

      if (otpResponse === "otp sent") {
        const signupData = {
          firstname: formik.values.firstname,
          lastname: formik.values.lastname,
          email: formik.values.email,
          phoneNumber: formik.values.phoneNumber,
          password: formik.values.confirmNewPassword,
          companyName: formik.values.companyName,
          aboutUs: formik.values.aboutUs,
        };
        setTempAdminSignupData(signupData);
        sessionStorage.setItem("tempSignupData", JSON.stringify(signupData));
        sessionStorage.setItem("tempEmail", formik.values.email);
        setShowOtpPage(true);
        Toast("success", "OTP sent to your email!");
      } else {
        throw new Error("Failed to send OTP");
      }
    } catch (error) {
      console.error("Send OTP Error:", error?.response?.data || error.message);
      Toast("error", error?.response?.data || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      phoneNumber: "",
      newpassword: "",
      confirmNewPassword: "",
      companyName: "",
      aboutUs: "",
    },
    validationSchema: validationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      if (formik.isValid) {
        await handleSendOTP();
      } else {
        console.error("Form validation failed:", formik.errors);
        Toast("error", "Please fix the form errors before submitting");
      }
    },
  });

  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      const formattedPhone = phone.startsWith("+") ? phone : `+${phone}`;
      formik.setFieldValue("phoneNumber", formattedPhone);
      formik.setFieldTouched("phoneNumber", true, false);
      formik.validateField("phoneNumber");
    },
    [formik],
  );

  return (
    <>
      {showOtpPage ? (
        <VerifyOtp />
      ) : (
        <div className="signup-outer-main-container">
          <div className="signup-header-section">
            <img src={accountIcon} alt="accountIcon" />
            <div className="signup-header-texts">
              <h2 className="signup-main-header">Create Your Account</h2>
              <span className="signup-side-text">
                Let's get started with your VybogTAL journey.
              </span>
            </div>
          </div>
          <div className="signup-fields-section">
            <DynamicTextField
              label={"First Name"}
              name={"firstname"}
              placeholder={"Enter Your First Name"}
              value={formik.values.firstname}
              onChange={formik.handleChange}
              required={true}
              error={formik.errors.firstname && formik.touched.firstname}
              errorMessage={formik.errors.firstname}
              onBlur={formik.handleBlur}
            />
            <DynamicTextField
              label={"Last Name"}
              name={"lastname"}
              placeholder={"Enter Your Last Name"}
              value={formik.values.lastname}
              onChange={formik.handleChange}
              required={true}
              error={formik.errors.lastname && formik.touched.lastname}
              errorMessage={formik.errors.lastname}
              onBlur={formik.handleBlur}
            />
            <DynamicTextField
              label={"Email"}
              placeholder="Please Enter Your Email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              maxLength="50"
              required={true}
              error={formik.errors.email && formik.touched.email}
              errorMessage={formik.errors.email}
              onBlur={formik.handleBlur}
            />
            <PhoneNumberInput
              value={formik.values.phoneNumber}
              onChange={handlePhoneInputChange}
              onBlur={() => formik.setFieldTouched("phoneNumber", true)}
              error={formik.errors.phoneNumber}
              touched={formik.touched.phoneNumber}
              placeholder="Phone Number"
              label="Phone Number"
              height="41px"
              countryListWidth="200px"
              phoneContainerStyle={{ marginBottom: "14px" }}
              required={true}
              format="international"
              enableSearch={true}
              autoFormat={true}
            />
            <DynamicTextField
              type={"password"}
              label={"New Password"}
              placeholder="Enter Your New Password"
              name="newpassword"
              value={formik.values.newpassword}
              onChange={formik.handleChange}
              showPasswordToggle={true}
              required={true}
              error={formik.errors.newpassword && formik.touched.newpassword}
              errorMessage={formik.errors.newpassword}
              onBlur={formik.handleBlur}
            />
            <DynamicTextField
              type={"password"}
              label={"Confirm New Password"}
              placeholder="Re-enter Your New Password"
              name="confirmNewPassword"
              value={formik.values.confirmNewPassword}
              onChange={formik.handleChange}
              showPasswordToggle={true}
              required={true}
              error={
                formik.errors.confirmNewPassword &&
                formik.touched.confirmNewPassword
              }
              errorMessage={formik.errors.confirmNewPassword}
              onBlur={formik.handleBlur}
            />
            <div
              className="companyName-container"
              style={{ marginTop: "-2px" }}
            >
              <DynamicTextField
                label={"Company Name"}
                name={"companyName"}
                placeholder={"Enter Your Company Name"}
                value={formik.values.companyName}
                onChange={formik.handleChange}
                required={true}
                error={formik.errors.companyName && formik.touched.companyName}
                errorMessage={formik.errors.companyName}
                onBlur={formik.handleBlur}
              />
            </div>
            <div
              className="know-about-us-container"
              style={{ marginTop: "2px" }}
            >
              <h4 className="know-about-us-title" style={{ marginTop: "5px" }}>
                How Did You Hear About Us?
              </h4>
              <SelectInput
                // placeholder="Select"
                options={knowAboutUs}
                name="aboutUs"
                value={formik?.values?.aboutUs || ""}
                onBlur={formik?.handleBlur}
                error={formik?.touched?.aboutUs && formik?.errors?.aboutUs}
                errorMessage={formik?.errors?.aboutUs}
                onChange={formik?.handleChange}
                wrapperStyle={{
                  display: "flex",
                  width: "100%",
                  marginBottom: "15px",
                  marginTop: "-15px",
                }}
                labelStyle={{
                  fontSize: "16px",
                  fontWeight: 600,
                  width: "fit-content",
                  marginBottom: "12px",
                }}
              />
            </div>
          </div>
          <div className="signup-button-container">
            <Button
              isCancel={true}
              event={() => navigate("/signup")}
              label="Back"
              iconSrc={backIcon}
              iconPosition="left"
              iconWidth="22px"
            />
            <Button
              label={isLoading ? "Sending OTP..." : "Send OTP"}
              event={formik.handleSubmit}
              iconSrc={isLoading ? null : completeIcon}
              iconPosition="right"
              iconWidth="18px"
              disabled={isLoading}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default AdminSignup;
